import WMTS, { optionsFromCapabilities } from "ol/source/WMTS";
import WMTSCapabilities from "ol/format/WMTSCapabilities.js";

function wmts({ url, layers, layer, projection }) {
  try {
    const parser = new WMTSCapabilities();
    const result = parser.read(layers);

    const options = optionsFromCapabilities(result, {
      layer,
    });
    options.urls = [url];
    options.crossOrigin = "Anonymous";
    options.projection = projection;

    return new WMTS(options);
  } catch (err) {
    console.error(
      new Error(
        "[OLMap/wmts] - Error when constructing WMTS layer. This was most likely caused by a faulty url.",
        err
      )
    );
  }
}

export default wmts;
